<form class="cadastros-edit" ng-submit="edit.saveEstadio($event)" name="itemEditForm">
    <span>
      <h3 ng-show="!edit.estadio.edit">Novo Estadio</h3>
      <h3 ng-show="edit.estadio.edit">Editando <i>{{edit.estadio.descricao}}</i></h3>
    </span>
    <div class="row">
      <!-- Descricao -->
      <div class="col-xs-6">
        <div class="form-group">
          <label for="description" class="control-label">Descrição</label>
          <input type="text" ng-model="edit.editEstadio.descricao" name="description" id="description" required class="form-control">
        </div>
      </div>

        <!-- Abreviatura -->
      <div class="col-xs-6">
        <div class="form-group">
          <label for="abreviatura" class="control-label">Abreviatura</label>
          <input type="text" ng-model="edit.editEstadio.abreviatura" name="abreviatura" id="abreviatura" required class="form-control">
        </div>
      </div>
  
        <!-- Atividade -->
      <div class="col-xs-6">
        <div class="form-group">
          <label for="atividade" class="control-label">Atividade</label>
          <ui-select ng-required="edit.editEstadio.semente" name="atividade" id="atividade" ng-model="edit.editEstadio.atividade">
            <ui-select-match>{{$select.selected.descricao | capitalize}}</ui-select-match>
            <ui-select-choices repeat="atividade in edit.atividades| filter: $select.search">
              <span ng-bind-html="atividade.descricao | highlight: $select.search"></span>
            </ui-select-choices>
          </ui-select>
        </div>
      </div>


         <!-- Ordem do Laudo -->
      <div class="col-xs-6">
       <div class="form-group">
         <label for="ordem" class="control-label">Ordem do Laudo</label>
         <input type="text" ng-model="edit.editEstadio.ordem" name="ordem" id="ordem" required class="form-control">
       </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-xs-12 text-right">
        <button type="button" class="btn btn-white" ng-click="edit.cancel()" ng-disabled="edit.loading">Cancelar</button>
        <button type="submit" class="btn btn-success" ng-disabled="itemEditForm.$invalid || edit.loading">
          <span ng-show="!edit.loading">
            Salvar
            <i class="fa fa-save"></i>
          </span>
          <i class="fa fa-spinner fa-pulse fa-fw" ng-show="edit.loading"></i>
        </button>
      </div>
    </div>
  </form>
  